import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import { CERTIFICATE_LIST } from '../roles/roles.model';
import { REGION_CATEGORY_IMAGE_LIST } from '../../marketplace/marketplace.model';
import { AddProductComponent } from 'src/app/admin/sub-admin/add-product/add-product.component';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MarketplacePageComponent } from 'src/app/customers/marketplace/marketplace.component';
import { Location } from '@angular/common';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { QRCodeComponent } from 'angularx-qrcode';
import { SharedService } from '../../../shareModule/services/shared.service';
import { ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { CommonService } from 'src/app/shareModule/services/common.service';

declare const google: any;
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommunityProfileComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  public radarChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    aspectRatio: 1,
    layout: {
      padding: 0,
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  chartPopup: boolean = false;
  public radarChartLabels: string[] = [
    'Account Age',
    'No of Supporters',
    'Avg Level of Supporters',
    // 'Number of Orders',
    'No of Conversations',
    'Special Stats',
  ];

  public radarChartData: ChartData<'radar'> = {
    labels: this.radarChartLabels,
    datasets: [{ data: [0, 0, 0, 0, 0], label: '' }],
  };
  public radarChartType: ChartType = 'radar';

  // events
  public chartClicked({
    event,
    active,
  }: {
    event: ChartEvent;
    active: object[];
  }): void {
  }

  public chartHovered({
    event,
    active,
  }: {
    event: ChartEvent;
    active: object[];
  }): void {
  }

  @ViewChild('marketplace') marketplaceProfileSection: MarketplacePageComponent;
  @ViewChild('qrcode', { static: false }) qrcode: QRCodeComponent;

  public refer_friend_link: string = '';
  public subCategoryList: Array<any> = [];
  public totalMemberShopProductList: Array<any> = [];
  public currentCategoryName: string = '';
  public imgUrl = environment.ImageUrl;
  public roles = CERTIFICATE_LIST;
  public certificateImgUrl: string =
    environment.ImageUrl + 'public/images/certificate/';

  viewGrid: boolean = true;
  public tabs = [
    { title: 'Favorites' },
    { title: 'Sell' },
    { title: 'Rent' },
    { title: 'Donate' },
    { title: 'History' },
  ];
  loading = true;
  updateSelMenu(index: number) {
    this.selectMenu(index);
  }
  @ViewChild('AddShop') addProductComponent: AddProductComponent;

  handleChatNow() {
    this.sharedService.triggerChatNow({
      chatingNow: this.profile?.id,
      menu: 'chat',
      chatTitle: this.profile.profileCharacterName ?? 'User',
      lastSeenTime: this.profile.lastSeenTime,
    });
    // this.sharedService.triggerChatNow({ chatingNow: this.profile?.id, menu: 'chat', chatTitle: this.profile.profileCharacterName ?? "User" });
  }

  public categoriesList: Array<any> = [];
  public subcategoriesList: Array<any> = [];
  public regionList = REGION_CATEGORY_IMAGE_LIST;
  public selectedCategoryName = null;
  public selectedSubCategoryName = '';
  public shopExist: boolean = true;

  public addedCategoryList: Array<any> = [];
  public addedSubCategoryList: Array<any> = [];
  public selectedRegionForDD = '';
  public commonModalRef: any = null;
  public selectedSellOption: any = null;
  public profile: any = {
    certificates: [],
    appUserSupports: [],
  };
  public isShowingActions = false;
  public handleReport() {
    this.local.alertReport('', true)
      .then(
        res => {
          if (res.isConfirmed) {
            const report = res.value;

            this.auth
              .submitReportMessage({
                message: report.reportDetails,
                type: report.reportType,
                category: "member",
                product_id: this.profile.id,
              })
              .subscribe({
                next: () => {
                  this.toastr.success("Report submitted")
                },
                error: err => {
                  this.toastr.error(err.error.message)
                }
              })
          }
        }
      )

  }

  title = 'My Angular Google Maps App';
  lat: number = 1.3521;
  lng: number = 103.8198;
  map: any;
  geocoder: any;
  marker: any;
  postalCode: string = '';
  address: string = '';
  appUserId: any;
  isLogin: any = 0;

  tabs2 = [{ title: 'recommendations' }, { title: 'news' }, { title: 'supported' }, { title: 'experience' }];
  public recommCarConfig = {
    slidesPerView: 5,
    autoHeight: true,
    spaceBetween: 10,

    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    }
  };

  carouselOptionsSupported: any = {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      0: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 8,
      },
    },
  };

  constructor(
    private route: ActivatedRoute,
    public local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private _location: Location,
    private customerService: CustomerService,
    private router: Router,
    public roleService: RoleService,
    private clipboard: Clipboard,
    private sharedService: SharedService,
    private commonService: CommonService,
    @Inject("WINDOW") private window: any,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.sharedService.profileService$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      this.getFavoriteProducts()
    });

    this.checkIfLogin();

    this.modalService.dismissAll();

    this.route.paramMap.pipe(
      takeUntil(this.destroy$)
    ).subscribe((params) => {
      //queryParams
      if (params.get('code')) {
        this.getProfileInfo(params.get('code'));
      }
    });

    if (this.sharedService.isBrowser()) {
      this.getAllProductList();
      this.getFavoriteProducts();
      this.getSupported();

    }
  }

  ngOnDestroy(): void {
    // console.log('[Start Destroy] Profile')
    this.local.clearTimeout(this.timeout1)
    this.destroy$.next();
    this.destroy$.complete();
    // console.log('[End Destroy] Profile')
  }

  async share(link) {
    if ('share' in navigator) {
      try {
        await navigator.share({
          url: link
        })
      } catch (e) {
        console.error(e);
        this.toastr.error("Something went wrong while sharing")
      }
    } else {
      this.toastr.info("Your browser doesn't support Share API")
    }
  }



  goBack() {
    this.commonService.goBack();
  }

  checkIfLogin() {

    this.local.getUserDetailsObserver().pipe(
      takeUntil(this.destroy$)
    ).subscribe((user) => {
      if (user?.id) {
        this.appUserId = user.id;
        this.isLogin = 1;
        this.profile.isSupport = this.checkSupport();
      } else {
        this.isLogin = 0;
      }
    });
  }
  sortDirection: 'asc' | 'desc' = 'asc';
  sortName: string = '';
  sortProducts(property: any): void {
    this.sortName = property;
    const multiplier = this.sortDirection === 'asc' ? 1 : -1;

    this.productAllProductList.sort((a, b) => {
      let comparison = 0;

      if (property === 'name') {
        comparison = a.name.localeCompare(b.name);
      } else if (property === 'price') {
        comparison =
          a.memberShopProductsVariations[0].key -
          b.memberShopProductsVariations[0].key;
      } else if (property === 'created') {
        comparison = a.created - b.created;
      }
      return comparison * multiplier;
    });

    // Toggle the sort direction for next click
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  }

  convertDate(value: number) {
    return moment.unix(value).format('MMMM D, YYYY');
  }

  checkSupport() {
    return (
      this.profile.appUserSupports?.filter(
        (row: any) => row.member_id == this.appUserId
      ).length > 0
    );
  }

  public getProfileInfo(code: any) {
    this.customerService.getProfileInfo(code, true).pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      (response: any) => {
        this.refer_friend_link =
          this.window.location.protocol +
          '//' +
          this.window.location.hostname +
          '/profile/' +
          code;
        this.profile = response.body;
        this.getRecommendation();
        console.log('profile response', response.body)

        if (this.profile.bgBody) {
        }
        this.profile.certificates = this.profile?.certificates.filter(
          (row: any) => row.role != '' && row.role != null
        );

        if (this.profile.id == null) {
          this.toastr.warning('Invalid Link');
          this.router.navigateByUrl('/me/nearby');
          return;
        }
        try {
          this.profile.certified = JSON.parse(this.profile.certified);

        } catch (e) {
          this.profile.certified = []
          console.error(e)
        }

        this.profile.created = this.convertDate(this.profile.created);
        this.profile.isSupport = this.checkSupport();

        this.postalCode = this.profile.postalCode;
        if (this.sharedService.isBrowser()) {
          this.getProfileMatrix();
          this.getAllProductList();
        }
        this.getFavoriteProducts()
        this.getSupported();
        this.loading = false;

        this.cdr.detectChanges();
      },
      (e) => {
        this.toastr.warning('Invalid Link');
        this.router.navigateByUrl('/me/nearby');
        this.loading = false;
        this.cdr.detectChanges();
      }
    );
  }

  public getProfileMatrix() {
    this.customerService
      .getProfileMatrix(this.profile.id).pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((response: any) => {
        this.profile.matrix = response.body;
        this.radarChartData = {
          ...this.radarChartData,
          datasets: [
            {
              ...this.radarChartData.datasets[0],
              data: [
                this.profile.matrix.accountAge,
                this.profile.matrix.supporterCount,
                this.profile.matrix.avgLevelOfSupporters,
                this.profile.matrix.conversations,
                this.profile.matrix.specialStats,
              ],
            },
          ],
        };

      });
  }

  public userExperiences: any = {
    data: []
  };
  public getUserExperiences() {

    this.auth
      .getProductRecommendation({
        userId: this.profile.id
      }).pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((response: any) => {
        this.userExperiences = response.body;
      });
  }

  public userGallery: any = [];
  public getUserGallery() {
    this.customerService
      .userGallery({ userId: this.profile.id }).pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((response: any) => {
        this.userGallery = response.body;
      });
  }

  public handleSupportSeller() {
    if (!this.isLogin) {
      this.toastr.error('Please Login First!');
      return;
    }
    this.local
      .confirm({
        title: 'Support',
        text: `Do you wish to ${this.profile.isSupport ? 'unsupport' : 'support'} this business?`,
        icon: 'info',
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.customerService
            .addMemberSupport({
              businessId: this.profile.id,
              type: 'community',
            }).pipe(
              takeUntil(this.destroy$)
            )
            .subscribe({
              next: (response: any) => {
                // if (response.body) {
                //   this.profile.isSupport = true;
                // } else {
                //   this.profile.isSupport = false;
                // }
                this.profile.isSupport = !this.profile.isSupport
                this.toastr.success(response.message);
              },
              error: (e) => {
                this.toastr.error(e.error.message);
              },
            });
        } else {
          this.toastr.info('Support cancelled');
        }
      });
  }

  private _getSubCategoryList(selectedSubCategoryName = '') {
    let selectedCategoryId = this._getSelectedCategoryId(); // Need update
    this.auth
      .getAllMemberShopSubCategory({
        categoryId: selectedCategoryId,
      }).pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((response: any) => {
        this.addedSubCategoryList = response.body;
        this.selectedSubCategoryName = '';
      });
  }
  private _getSelectedCategoryId(): any {
    return (
      this.addedCategoryList.filter(
        (i: any) => i.name == this.selectedCategoryName
      )[0]?.id || 0
    );
  }
  public onCategoryChange(catName, subCatName): void {
    this._getSubCategoryList(subCatName);
  }

  public productAllProductList: Array<any> = [];
  public productAllProductListFavorites: Array<any> = []
  loadingProduct: boolean = true;
  public getAllProductList() {
    this.productAllProductList = [];
    // this.auth
    //   .getAllShopProduct()

    this.customerService
      .getAllShopProduct({
        categoryId: '',
        subCategoryId: '',
        userId: this.profile.id,
      }).pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(
        (response: any) => {
          this.productAllProductList = response.body;
          this.productAllProductListFiltered = this.productAllProductList;
          this.initMap();
          this.loadingProduct = false;
          this.cdr.detectChanges();
        },
        (e) => {
          this.toastr.error(e.error.message);
          this.initMap();
          this.loadingProduct = false;
          this.cdr.detectChanges();
        }
      );


  }


  public getFavoriteProducts() {

    this.customerService.getFavoriteProducts({
      userId: this.profile.id
    }).pipe(
      takeUntil(this.destroy$)
    ).subscribe((resp: any) => {
      this.productAllProductListFavorites = resp.body;
      this.cdr.detectChanges();
    })
  }

  public selMenu: any = 0;
  public filterProp = 'type';
  public filterValue: any = 'shop';
  public selectMenu(menu: any): void {
    this.selMenu = menu;
    if (menu == 2) {
      this.filterProp = 'type';
      this.filterValue = 'rental';
    } else if (menu == 1) {
      this.filterProp = 'type';
      this.filterValue = 'shop';
    } else if (menu == 3) {
      this.filterProp = 'type';
      this.filterValue = 'bless';
    } else if (menu == 4) {
      this.filterProp = 'type';
      this.filterValue = 'sold';
    } else {
      this.filterProp = 'type';
      this.filterValue = '';
    }
  }

  public selMenu2: any = 0;
  public selectMenu2(menu: any): void {
    this.selMenu2 = menu;


    if (menu == 0) {
      this.getSupported();
    } else if (menu == 1) {
      this.getUserExperiences();
    }
  }

  showImageGallery: any = {};
  openShowImageModal(modal, image) {
    this.showImageGallery = image;
    this.modalService.open(modal, {
      windowClass: 'my-show-image-modal',
    });
  }

  public regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : '';
  }

  timeout1: any;
  initMap(): void {
    if (this.sharedService.isBrowser() && document.getElementById('map-profile')) {
      this.local.clearTimeout(this.timeout1)
      this.timeout1 = setTimeout(() => {
        this.map = new google.maps.Map(document.getElementById('map-profile'), {
          center: { lat: this.lat, lng: this.lng },
          zoom: 12,
          restriction: {
            latLngBounds: {
              north: 1.47,
              south: 1.22,
              east: 104.05,
              west: 103.62
            },
            strictBounds: true
          }
        });

        this.geocoder = new google.maps.Geocoder();

        if (this.postalCode != '') this.geocodePostalCode();
      }, 100);
    }
  }

  placeMarkerAndPanTo(latLngData: any): void {
    let latLng = latLngData
    try {
      latLng = JSON.parse(latLng)
    } catch (e) {
      latLng = latLngData
    }

    if (this.marker) {
      this.marker.setPosition(latLng);
    } else {
      this.marker = new google.maps.Marker({
        position: latLng,
        map: this.map,
        restriction: {
          latLngBounds: {
            north: 1.47,
            south: 1.22,
            east: 104.05,
            west: 103.62
          },
          strictBounds: true
        }
      });
    }
    this.map.panTo(latLng);
  }

  async geocodePostalCode(): Promise<void> {
    this.placeMarkerAndPanTo(await this.local.getLatLongByPostalCode(this.postalCode))
    // this.geocoder.geocode(
    //   { address: this.postalCode },
    //   (results: any, status: any) => {
    //     if (status === 'OK') {
    //       const location = results[0].geometry.location;
    //       const latLong = { lat: location.lat(), lng: location.lng() };
    //       this.placeMarkerAndPanTo(latLong);
    //     } else {
    //     }
    //   }
    // );
  }

  public viewProductDetails(product): void {
    this.marketplaceProfileSection.enableMemberShop = product.enableMemberShop;
    this.marketplaceProfileSection.viewProduct(product);
  }

  public productAllProductListFiltered: Array<any> = [];
  public filterProduct(event: any) {
    this.productAllProductListFiltered = this.productAllProductList.filter(
      (product) => {
        return (
          product.name
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          product.description
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
        );
      }
    );
  }

  public setProfileToDefault(type = 'default') {
    this.local
      .alertConfirm({
        message: 'Are you sure you want to set your profile to default?',
      })
      .then((result) => {
        if (result.value) {
          this.customerService
            .setProfileToDefault({
              referralCode: this.profile.referralCode,
              level: this.profile.level,
              type: type,
            }).pipe(
              takeUntil(this.destroy$)
            )
            .subscribe(
              (response: any) => {
                this.toastr.success(
                  response.message || 'Profile set to default successfully'
                );
                this.getProfileInfo(this.profile.referralCode);
              },
              (e) => {
                this.toastr.error(
                  e.error.message || 'Failed to set profile to default'
                );
              }
            );
        }
      });
  }

  setProfileToAvatar() {
    this.setProfileToDefault('avatar');
  }

  public muteProfile() {
    this.customerService
      .updateUserMuteStatus({
        userId: this.profile.id,
      }).pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message || 'Profile muted successfully');
        },
        (e) => {
          this.toastr.error(e.error.message || 'Failed to mute profile');
        }
      );
  }

  public blockProfile() {
    this.customerService
      .updateUserBlockStatus({
        userId: this.profile.id,
      }).pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(
        (response: any) => {
          this.toastr.success(
            response.message || 'Profile blocked successfully'
          );
        },
        (e) => {
          this.toastr.error(e.error.message || 'Failed to block profile');
        }
      );
  }

  public shareMyProfile(modal) {
    this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  public copyReferralLink() {
    this.clipboard.copy(this.refer_friend_link);
    this.toastr.success('Profile Link Copied!');
  }

  public downloadQRCode() {
    const qrElement =
      this.qrcode.qrcElement.nativeElement.querySelector('canvas');

    if (qrElement) {
      const qrCodeDataUrl = qrElement.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = qrCodeDataUrl;
      link.download = 'qr-code.png';
      link.click();
    }
  }
  recommendations = []

  public getRecommendation() {
    console.log('user profile is', this.profile)
    this.auth.getallrecommendations({

      selectAllRegions: true,
      categries: [],
      userId: this.profile?.id
    }).subscribe({
      next: (data: any) => {
        this.recommendations = data.data
      },
      error: console.error
    })

  }

  supported: any[] = [];
  getSupported() {
    this.customerService.getUserSupportList().pipe(
      takeUntil(this.destroy$)
    ).subscribe((resp: ApiResponse) => {
      this.supported = resp.body.map((i: any) => {
        return {
          ...i,
          sellerImage:
            i.type == 'community'
              ? i.businessDetails?.profileCharacterImageFile
              : i.userDetails.shop_logo,
          sellerName:
            i.type == 'community'
              ? i.businessDetails?.profileCharacterName
              : i?.userDetails?.first_name + ' ' + i?.userDetails?.last_name,
        };
      });
      this.cdr.detectChanges();
    });
  }

  navigateToShop(item: any) {

    if (item.category == 'community') {
      this.router.navigate(['/profile', item.sellerReferralCode]);
    } else {
      this.router.navigate(['/biz/shop', item.userDetails?.user_id]);
    }
  }
}
